import { useEffect } from 'react';
import { useDispatch } from '../actions/types';
import { Actions as PageActions } from '../actions/page';
import { useQueryParam, StringParam } from 'use-query-params';
export default function usePageNavStart(matchedRoute) {
    // console.log('1. usePageNavStart: ', { matchedRoute });
    const dispatch = useDispatch();
    const [queryParam] = useQueryParam('query', StringParam);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        // console.log('2. usePageNavStart: ', JSON.stringify(matchedRoute, null, 2));
        if (((_a = matchedRoute.route.component) === null || _a === void 0 ? void 0 : _a.displayName) === 'ArticlePage') {
            // @ts-ignore
            const articleMatch = matchedRoute.match.params.articleId.match(/^\d+/);
            const articleId = articleMatch ? articleMatch[0] : '';
            dispatch(PageActions.pageNavStart({
                pageType: 'article',
                articleId,
                path: window.location.pathname,
            }));
            return;
        }
        if (((_b = matchedRoute.route.component) === null || _b === void 0 ? void 0 : _b.displayName) === 'CategoryPage') {
            // @ts-ignore
            const categoryMatch = matchedRoute.match.params.categoryId.match(/^\d+/);
            const categoryId = categoryMatch ? categoryMatch[0] : '';
            dispatch(PageActions.pageNavStart({
                pageType: 'category',
                categoryId,
                path: window.location.pathname,
            }));
            return;
        }
        if (((_c = matchedRoute.route.component) === null || _c === void 0 ? void 0 : _c.displayName) === 'HomePage') {
            dispatch(PageActions.pageNavStart({
                pageType: 'home',
                path: window.location.pathname,
            }));
            return;
        }
        if (((_d = matchedRoute.route.component) === null || _d === void 0 ? void 0 : _d.displayName) === 'Error404Page') {
            dispatch(PageActions.pageNavComplete({
                pageType: 'error404',
                path: window.location.pathname,
            }));
            return;
        }
        if (((_e = matchedRoute.route.component) === null || _e === void 0 ? void 0 : _e.displayName) === 'Error401Page') {
            dispatch(PageActions.pageNavComplete({
                pageType: 'error401',
                path: window.location.pathname,
            }));
            return;
        }
        if (
        // @ts-ignore
        matchedRoute.route.component.displayName === 'SearchPage' &&
            queryParam) {
            dispatch(PageActions.pageNavStart({
                pageType: 'search',
                searchTerm: queryParam,
                path: window.location.pathname,
            }));
        }
        // We must be at an extra route.
        if (((_f = matchedRoute.route.component) === null || _f === void 0 ? void 0 : _f.displayName) !== 'SearchPage') {
            dispatch(PageActions.pageNavComplete({
                pageType: 'extra',
                path: window.location.pathname,
            }));
        }
        // I only want this effect to run when either of these change, thus the eslint-disable
    }, [matchedRoute.match.url, queryParam]); // eslint-disable-line
}
//# sourceMappingURL=usePageNav.js.map